import type { Category, EventItem } from "@/types";

export const categories: Category[] = [
  {
    id: "basketball",
    name: "篮球",
    english: "Basketball",
    desc: "覆盖 NBA、CBA 及欧洲顶级联赛的每日赛程与战报，跟踪各支球队的近期状态与排名变化。",
    icon: "ri-basketball-line",
    cover:
      "https://readdy.ai/api/search-image?query=dynamic%20orange%20basketball%20on%20wooden%20court%20floor%20with%20dramatic%20arena%20lighting%20dark%20background%20editorial%20sports%20photography%20high%20detail&width=800&height=600&seq=cat-basketball-01&orientation=landscape",
    subs: ["NBA", "CBA", "欧洲联赛", "NCAA"],
  },
  {
    id: "football",
    name: "足球",
    english: "Football",
    desc: "英超、西甲、欧冠与中超赛事全覆盖，实时呈现进球、积分榜与转会动态。",
    icon: "ri-football-line",
    cover:
      "https://readdy.ai/api/search-image?query=soccer%20ball%20resting%20on%20green%20stadium%20grass%20at%20night%20with%20blurred%20floodlights%20dramatic%20depth%20of%20field%20editorial%20sports%20photography&width=800&height=600&seq=cat-football-01&orientation=landscape",
    subs: ["英超", "西甲", "中超", "欧冠"],
  },
  {
    id: "tennis",
    name: "网球",
    english: "Tennis",
    desc: "四大满贯与 ATP、WTA 巡回赛赛程结果，球员排名与场地表现一网打尽。",
    icon: "ri-trophy-line",
    cover:
      "https://readdy.ai/api/search-image?query=tennis%20racket%20and%20yellow%20ball%20on%20blue%20hard%20court%20with%20sunlight%20and%20long%20shadow%20minimal%20clean%20composition%20editorial%20sports&width=800&height=600&seq=cat-tennis-01&orientation=landscape",
    subs: ["大满贯", "ATP", "WTA", "戴维斯杯"],
  },
  {
    id: "tabletennis",
    name: "乒乓球",
    english: "Table Tennis",
    desc: "WTT 系列赛与全国锦标赛赛程，国手对决与新生代选手表现追踪。",
    icon: "ri-ping-pong-line",
    cover:
      "https://readdy.ai/api/search-image?query=table%20tennis%20paddle%20and%20white%20ball%20on%20green%20table%20with%20net%20soft%20indoor%20lighting%20clean%20minimal%20sports%20composition&width=800&height=600&seq=cat-tt-01&orientation=landscape",
    subs: ["WTT", "全锦赛", "世界杯"],
  },
  {
    id: "esports",
    name: "电竞",
    english: "Esports",
    desc: "英雄联盟、DOTA2、CS2 顶级赛事赛程与战报，战队积分与选手数据一站掌握。",
    icon: "ri-gamepad-line",
    cover:
      "https://readdy.ai/api/search-image?query=esports%20gaming%20arena%20with%20colorful%20stage%20lights%20and%20large%20screens%20dark%20atmosphere%20purposeful%20technology%20vibe%20editorial%20photography&width=800&height=600&seq=cat-esports-01&orientation=landscape",
    subs: ["英雄联盟", "DOTA2", "CS2", "王者荣耀"],
  },
  {
    id: "racing",
    name: "赛车",
    english: "Motorsport",
    desc: "F1 与 MotoGP 分站赛程、排位与正赛结果，车手积分榜实时更新。",
    icon: "ri-roadster-line",
    cover:
      "https://readdy.ai/api/search-image?query=motorsport%20race%20car%20on%20asphalt%20track%20with%20motion%20blur%20and%20dramatic%20sunset%20lighting%20editorial%20sports%20photography%20high%20detail&width=800&height=600&seq=cat-racing-01&orientation=landscape",
    subs: ["F1", "MotoGP", "FE"],
  },
  {
    id: "volleyball",
    name: "排球",
    english: "Volleyball",
    desc: "世界女排联赛与各国联赛赛程结果，攻防数据与球队排名深度解析。",
    icon: "ri-medal-line",
    cover:
      "https://readdy.ai/api/search-image?query=volleyball%20ball%20mid%20air%20near%20net%20in%20bright%20indoor%20arena%20with%20clean%20background%20dynamic%20sports%20composition&width=800&height=600&seq=cat-volley-01&orientation=landscape",
    subs: ["世界联赛", "国内联赛", "锦标赛"],
  },
];

const logoA =
  "https://readdy.ai/api/search-image?query=minimal%20orange%20shield%20emblem%20team%20badge%20logo%20on%20plain%20light%20background%20flat%20vector%20style&width=200&height=200&seq=logo-team-a&orientation=squarish";
const logoB =
  "https://readdy.ai/api/search-image?query=minimal%20blue%20circular%20emblem%20team%20badge%20logo%20on%20plain%20light%20background%20flat%20vector%20style&width=200&height=200&seq=logo-team-b&orientation=squarish";

export const events: EventItem[] = [
  {
    id: "ev-1001",
    title: "NBA 常规赛 湖人 vs 凯尔特人",
    categoryId: "basketball",
    categoryName: "篮球",
    subCategory: "NBA",
    date: "2026-10-15",
    time: "09:30",
    venue: "洛杉矶 Crypto.com 球馆",
    level: "常规赛",
    status: "live",
    home: { name: "洛杉矶湖人", logo: logoA },
    away: { name: "波士顿凯尔特人", logo: logoB },
    homeScore: 78,
    awayScore: 74,
    cover:
      "https://readdy.ai/api/search-image?query=professional%20basketball%20players%20jumping%20for%20rebound%20in%20packed%20arena%20dramatic%20spotlight%20dark%20background%20editorial%20sports%20photography%20high%20detail&width=1200&height=675&seq=ev-basketball-01&orientation=landscape",
    summary:
      "西部劲旅与东部豪门正面对话，两队近期状态火热，本场被视为季初的风向标之战。",
    recap:
      "比赛第三节双方展开拉锯，湖人凭借内线优势保持微弱领先，凯尔特人外线手感回暖紧咬比分。第四节悬念仍在延续。",
    tags: ["NBA", "焦点战", "每日大赛"],
    featured: true,
  },
  {
    id: "ev-1002",
    title: "英超第 9 轮 曼城 vs 利物浦",
    categoryId: "football",
    categoryName: "足球",
    subCategory: "英超",
    date: "2026-10-15",
    time: "03:00",
    venue: "伊蒂哈德球场",
    level: "联赛",
    status: "finished",
    home: { name: "曼城", logo: logoB },
    away: { name: "利物浦", logo: logoA },
    homeScore: 2,
    awayScore: 1,
    cover:
      "https://readdy.ai/api/search-image?query=football%20match%20action%20shot%20in%20packed%20night%20stadium%20with%20green%20pitch%20and%20blurred%20crowd%20editorial%20sports%20photography%20high%20detail&width=1200&height=675&seq=ev-football-01&orientation=landscape",
    summary: "英超榜首之争，两支争冠热门在赛季初就提前上演强强对话。",
    recap:
      "曼城上半场由边路传中率先破门，利物浦下半场扳平比分；终场前曼城通过一次定位球机会再入一球，最终 2:1 险胜。",
    tags: ["英超", "强强对话", "每日大赛"],
    featured: true,
  },
  {
    id: "ev-1003",
    title: "WTT 球星挑战赛 男单半决赛",
    categoryId: "tabletennis",
    categoryName: "乒乓球",
    subCategory: "WTT",
    date: "2026-10-15",
    time: "14:00",
    venue: "澳门体育中心",
    level: "半决赛",
    status: "upcoming",
    home: { name: "王楚钦", logo: logoA },
    away: { name: "林诗栋", logo: logoB },
    homeScore: null,
    awayScore: null,
    cover:
      "https://readdy.ai/api/search-image?query=table%20tennis%20player%20smashing%20ball%20in%20professional%20indoor%20arena%20with%20blue%20floor%20and%20spotlight%20editorial%20sports%20photography&width=1200&height=675&seq=ev-tt-01&orientation=landscape",
    summary: "国乒德比提前上演，两位主力争夺决赛席位，交手记录互有胜负。",
    recap: "赛事尚未开始，敬请关注实时比分更新。",
    tags: ["乒乓球", "半决赛", "国乒"],
    featured: false,
  },
  {
    id: "ev-1004",
    title: "F1 新加坡大奖赛 正赛",
    categoryId: "racing",
    categoryName: "赛车",
    subCategory: "F1",
    date: "2026-10-16",
    time: "20:00",
    venue: "滨海湾街道赛道",
    level: "大奖赛",
    status: "upcoming",
    home: { name: "法拉利车队", logo: logoA },
    away: { name: "迈凯伦车队", logo: logoB },
    homeScore: null,
    awayScore: null,
    cover:
      "https://readdy.ai/api/search-image?query=formula%20one%20race%20car%20speeding%20through%20night%20city%20street%20circuit%20with%20illuminated%20buildings%20and%20sparks%20editorial%20motorsport%20photography&width=1200&height=675&seq=ev-racing-01&orientation=landscape",
    summary: "夜赛与街道赛的双重考验，车队策略与进站时机将成为胜负关键。",
    recap: "赛事将于 10 月 16 日晚进行，赛前排位赛结果将于当日更新。",
    tags: ["F1", "夜赛", "街道赛"],
    featured: true,
  },
  {
    id: "ev-1005",
    title: "英雄联盟 全球总决赛 八强赛",
    categoryId: "esports",
    categoryName: "电竞",
    subCategory: "英雄联盟",
    date: "2026-10-15",
    time: "17:00",
    venue: "首尔电竞体育馆",
    level: "淘汰赛",
    status: "upcoming",
    home: { name: "JDG 电子竞技", logo: logoA },
    away: { name: "T1", logo: logoB },
    homeScore: null,
    awayScore: null,
    cover:
      "https://readdy.ai/api/search-image?query=esports%20tournament%20stage%20with%20big%20led%20screens%20and%20crowd%20silhouettes%20colorful%20stage%20lighting%20dark%20arena%20editorial%20photography&width=1200&height=675&seq=ev-esports-01&orientation=landscape",
    summary: "LPL 与 LCK 的正面碰撞，八强淘汰赛一场定生死，版本理解成为关键。",
    recap: "比赛将于 17:00 开始，赛后将更新详细战报与数据面板。",
    tags: ["电竞", "全球总决赛", "淘汰赛"],
    featured: false,
  },
  {
    id: "ev-1006",
    title: "中国网球公开赛 女单决赛",
    categoryId: "tennis",
    categoryName: "网球",
    subCategory: "WTA",
    date: "2026-10-14",
    time: "19:30",
    venue: "国家网球中心钻石球场",
    level: "决赛",
    status: "finished",
    home: { name: "郑钦文", logo: logoA },
    away: { name: "萨巴伦卡", logo: logoB },
    homeScore: 2,
    awayScore: 0,
    cover:
      "https://readdy.ai/api/search-image?query=tennis%20player%20serving%20on%20center%20court%20under%20night%20lights%20blue%20hard%20court%20blurred%20crowd%20editorial%20sports%20photography&width=1200&height=675&seq=ev-tennis-01&orientation=landscape",
    summary: "本土作战的头号种子迎战世界顶尖选手，冠军归属牵动球迷目光。",
    recap:
      "决赛中郑钦文发球局表现稳定，两盘 6:4、6:3 直落对手，成功捧起中网女单冠军奖杯。",
    tags: ["网球", "决赛", "中网"],
    featured: false,
  },
  {
    id: "ev-1007",
    title: "CBA 常规赛 辽宁 vs 广东",
    categoryId: "basketball",
    categoryName: "篮球",
    subCategory: "CBA",
    date: "2026-10-16",
    time: "19:35",
    venue: "沈阳奥体中心",
    level: "常规赛",
    status: "upcoming",
    home: { name: "辽宁本钢", logo: logoA },
    away: { name: "广东华南虎", logo: logoB },
    homeScore: null,
    awayScore: null,
    cover:
      "https://readdy.ai/api/search-image?query=basketball%20game%20arena%20wide%20shot%20with%20orange%20court%20and%20bright%20spotlights%20fans%20energy%20editorial%20sports%20photography&width=1200&height=675&seq=ev-cba-01&orientation=landscape",
    summary: "传统豪门对决，两队新赛季阵容调整后首次交锋，内线对抗看点十足。",
    recap: "比赛将于 10 月 16 日 19:35 进行，赛前发布会信息同步更新。",
    tags: ["CBA", "焦点战"],
    featured: false,
  },
  {
    id: "ev-1008",
    title: "欧冠小组赛 皇马 vs 拜仁",
    categoryId: "football",
    categoryName: "足球",
    subCategory: "欧冠",
    date: "2026-10-17",
    time: "03:00",
    venue: "伯纳乌球场",
    level: "小组赛",
    status: "upcoming",
    home: { name: "皇家马德里", logo: logoB },
    away: { name: "拜仁慕尼黑", logo: logoA },
    homeScore: null,
    awayScore: null,
    cover:
      "https://readdy.ai/api/search-image?query=football%20stadium%20at%20night%20with%20full%20crowd%20and%20green%20pitch%20under%20bright%20floodlights%20epic%20atmosphere%20editorial%20sports%20photography&width=1200&height=675&seq=ev-ucl-01&orientation=landscape",
    summary: "欧洲德比再度上演，两支欧冠常客在小组赛狭路相逢。",
    recap: "赛事将于 10 月 17 日凌晨开球，敬请关注。",
    tags: ["欧冠", "欧洲德比"],
    featured: false,
  },
  {
    id: "ev-1009",
    title: "世界女排联赛 中国 vs 巴西",
    categoryId: "volleyball",
    categoryName: "排球",
    subCategory: "世界联赛",
    date: "2026-10-15",
    time: "20:00",
    venue: "天津体育馆",
    level: "分站赛",
    status: "live",
    home: { name: "中国女排", logo: logoA },
    away: { name: "巴西女排", logo: logoB },
    homeScore: 2,
    awayScore: 1,
    cover:
      "https://readdy.ai/api/search-image?query=volleyball%20players%20spiking%20over%20net%20in%20bright%20indoor%20arena%20with%20clean%20background%20dynamic%20sports%20photography&width=1200&height=675&seq=ev-volley-01&orientation=landscape",
    summary: "中巴两队在分站赛正面交锋，拦网与一传质量决定比赛走向。",
    recap: "目前中国女排大比分 2:1 领先，第四局正在进行中。",
    tags: ["排球", "世界联赛"],
    featured: false,
  },
  {
    id: "ev-1010",
    title: "ATP 上海大师赛 男单四强",
    categoryId: "tennis",
    categoryName: "网球",
    subCategory: "ATP",
    date: "2026-10-13",
    time: "16:00",
    venue: "旗忠森林体育城",
    level: "半决赛",
    status: "finished",
    home: { name: "德约科维奇", logo: logoB },
    away: { name: "阿尔卡拉斯", logo: logoA },
    homeScore: 0,
    awayScore: 2,
    cover:
      "https://readdy.ai/api/search-image?query=tennis%20match%20on%20outdoor%20hard%20court%20with%20afternoon%20sun%20and%20long%20shadows%20clean%20editorial%20sports%20photography&width=1200&height=675&seq=ev-atp-01&orientation=landscape",
    summary: "新老天王的对决，年轻一代能否延续强势冲击成为最大悬念。",
    recap: "阿尔卡拉斯直落两盘 6:4、7:5 击败德约科维奇，晋级决赛。",
    tags: ["网球", "大师赛"],
    featured: false,
  },
  {
    id: "ev-1011",
    title: "CS2 亚洲邀请赛 决赛",
    categoryId: "esports",
    categoryName: "电竞",
    subCategory: "CS2",
    date: "2026-10-18",
    time: "18:00",
    venue: "上海电竞中心",
    level: "决赛",
    status: "upcoming",
    home: { name: "TYLOO", logo: logoA },
    away: { name: "The MongolZ", logo: logoB },
    homeScore: null,
    awayScore: null,
    cover:
      "https://readdy.ai/api/search-image?query=esports%20stage%20with%20blue%20and%20orange%20lighting%20and%20large%20screens%20dark%20arena%20crowd%20silhouette%20editorial%20photography&width=1200&height=675&seq=ev-cs2-01&orientation=landscape",
    summary: "亚洲顶尖战队会师决赛，争夺冠军奖杯与高额积分。",
    recap: "决赛将于 10 月 18 日 18:00 开赛。",
    tags: ["电竞", "CS2", "决赛"],
    featured: false,
  },
  {
    id: "ev-1012",
    title: "MotoGP 日本站 正赛",
    categoryId: "racing",
    categoryName: "赛车",
    subCategory: "MotoGP",
    date: "2026-10-16",
    time: "13:00",
    venue: "茂木赛道",
    level: "分站赛",
    status: "upcoming",
    home: { name: "杜卡迪车队", logo: logoA },
    away: { name: "雅马哈车队", logo: logoB },
    homeScore: null,
    awayScore: null,
    cover:
      "https://readdy.ai/api/search-image?query=motogp%20motorcycle%20racing%20on%20track%20with%20lean%20angle%20and%20motion%20blur%20dramatic%20daylight%20editorial%20motorsport%20photography&width=1200&height=675&seq=ev-motogp-01&orientation=landscape",
    summary: "日本站历来竞争激烈，轮胎策略与弯道超车成为看点。",
    recap: "赛事将于 10 月 16 日 13:00 发车。",
    tags: ["MotoGP", "日本站"],
    featured: false,
  },
  {
    id: "ev-1013",
    title: "NBA 常规赛 勇士 vs 掘金",
    categoryId: "basketball",
    categoryName: "篮球",
    subCategory: "NBA",
    date: "2026-10-17",
    time: "10:00",
    venue: "大通中心球馆",
    level: "常规赛",
    status: "upcoming",
    home: { name: "金州勇士", logo: logoA },
    away: { name: "丹佛掘金", logo: logoB },
    homeScore: null,
    awayScore: null,
    cover:
      "https://readdy.ai/api/search-image?query=basketball%20dunk%20action%20in%20modern%20arena%20with%20orange%20and%20dark%20tones%20dramatic%20lighting%20editorial%20sports%20photography&width=1200&height=675&seq=ev-nba2-01&orientation=landscape",
    summary: "外线投射与内线强攻的风格碰撞，西部排名之争提前升温。",
    recap: "比赛将于 10 月 17 日 10:00 开打。",
    tags: ["NBA", "西部焦点"],
    featured: false,
  },
  {
    id: "ev-1014",
    title: "乒乓球全锦赛 女团决赛",
    categoryId: "tabletennis",
    categoryName: "乒乓球",
    subCategory: "全锦赛",
    date: "2026-10-14",
    time: "15:00",
    venue: "黄石体育馆",
    level: "决赛",
    status: "finished",
    home: { name: "山东队", logo: logoA },
    away: { name: "河北队", logo: logoB },
    homeScore: 3,
    awayScore: 1,
    cover:
      "https://readdy.ai/api/search-image?query=table%20tennis%20doubles%20match%20in%20bright%20gymnasium%20with%20green%20tables%20and%20clean%20background%20editorial%20sports%20photography&width=1200&height=675&seq=ev-tt2-01&orientation=landscape",
    summary: "全锦赛女团巅峰对决，两队主力阵容悉数登场。",
    recap: "山东队以 3:1 战胜河北队，成功卫冕女子团体冠军。",
    tags: ["乒乓球", "全锦赛", "决赛"],
    featured: false,
  },
];